import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { AuthorizationService } from '@src/app/helpers/authorization.service';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';
import { Orgfile } from '../fileupload/model/orgfile';
import { Listfilter } from './model/filter';
import { FilelistService } from './service/filelist.service';
import { fileBaseName } from '@src/app/helpers/fileName.helper';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';
import { HttpClient } from '@angular/common/http';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-filelist',
  templateUrl: './filelist.component.html',
  styleUrls: ['./filelist.component.css']
})
export class FilelistComponent implements OnInit, OnChanges {
  readonly fileBaseName = fileBaseName;
  filelist: Orgfile[] = [];
  filteredfilelist: Orgfile[] = [];
  fileCache: Map<string, Blob> = new Map(); // Cache for file blobs
  @Input() entityid: string;
  @Input() projectId: string;
  @Input() modal: boolean;
  @Input() filetype: string;
  @Input() viewtype: string;
  @Input() reloadTrigger: number = 0;
  @Output() numberOfFiles = new EventEmitter<number>(true);
  @Input() fileToAdd: Orgfile;
  @Input() list: boolean = true;
  deleteconfirm: boolean = false;
  filetoggler: boolean = false;
  showFilters: boolean = false;
  fileToDelete: Orgfile;
  showNoFilesMsg: boolean = false;
  showSpinner: boolean = true;
  activeFilters: Listfilter[] = [];
  filters: Listfilter[] = [];
  filteredfilter: Listfilter[] = [];
  filtertext: string = '';
  togglertasklistfiles: string;
  toggledeletefile: string;
  @Input() textColor: boolean = false;

  constructor(
    private flsrv: FilelistService,
    private auth: AuthorizationService,
    private router: Router,
    private uieventhub: UieventhubService,
    private datastore: DatastoreService,
    private http: HttpClient
  ) { }

  getSignedUrl(file: Orgfile): void {
    this.flsrv.getSignedUrl(file.filename).pipe(untilDestroyed(this)).subscribe(url => {
      //console.log('url', url.url);
      this.http.get(url.url, { responseType: 'blob' }).pipe(untilDestroyed(this)).subscribe(blob => {
        // Create an anchor element and trigger the download
        const link = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        link.href = objectUrl;
        link.download = fileBaseName(file.filename);
        link.click();
        URL.revokeObjectURL(objectUrl); // Clean up
      });
    });
  }
  removeFromFilter(remove: Listfilter): void {
    let index = this.filters.findIndex(x => x.entity === remove.entity);
    if (index > -1) {
      this.filters[index].state = 'filter';
      this.filteredfilter = this.filters.filter(f => f.state === 'filter');
      this.activeFilters = this.filters.filter(f => f.state === 'active');
      this.filterfilelist();
    }
  }

  addToFilter(add: string): void {
    let index = this.filters.findIndex(x => x.entity === add);
    if (index > -1) {
      this.filters[index].state = 'active';
      this.filteredfilter = this.filters.filter(f => f.state === 'filter');
      this.activeFilters = this.filters.filter(f => f.state === 'active');
      this.filterfilelist();
    }
  }

  fileToggle(file: Orgfile) {
    this.toggledeletefile = file.fileId;
  }

  fileToggleof() {
    this.toggledeletefile = null;
  }

  navigate(t: string): void {
    SessionHelper.setCurrentProject(t);
    this.uieventhub.setCurrentProject(t);
    this.router.navigate(['/portal/project/' + t]);
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['fileToAdd'] && changes['fileToAdd'].currentValue) {
      this.addFileToList(changes['fileToAdd'].currentValue);
    }
    if (changes['reloadTrigger'] && !changes['reloadTrigger'].firstChange) {
      this.loadFiles();
    }
  }

  addFileToList(file: Orgfile) {
    // A reload triggered by a task update can already have fetched this same
    // file from the backend before this (locally emitted) copy arrives.
    if (this.filelist.some(f => this.isSameFile(f, file))) {
      return;
    }

    this.filelist.push(file);
    this.numberOfFiles.emit(this.filelist.length);

    if (this.filelist.length === 0) {
      this.showNoFilesMsg = true;
      this.showSpinner = false;
    }

    this.loadFileContent(file);
  }

  private isSameFile(a: Orgfile, b: Orgfile): boolean {
    if (a.fileId && b.fileId) {
      return a.fileId === b.fileId;
    }
    return a.filename === b.filename;
  }

  // Load file content (Blob) from cache or fetch if not available
  loadFileContent(file: Orgfile) {
    if (this.fileCache.has(file.filename)) {
      // If the file blob is cached, use the cached blob
      file.fileurl = URL.createObjectURL(this.fileCache.get(file.filename)!);
    } else {
      // Fetch the file content using signed URL
      this.flsrv.getSignedUrl(file.filename).pipe(untilDestroyed(this)).subscribe(url => {
        this.flsrv.fetchFileContent(url.url).pipe(untilDestroyed(this)).subscribe(blob => {
          // Cache the file blob
          this.fileCache.set(file.filename, blob);
          // Create an object URL from the Blob and set it as the file URL
          file.fileurl = URL.createObjectURL(blob);
          //this.auth.refreshPersonAuth(SessionHelper.getUserSub());
        });
      });
    }
  }

  candeletefile(f: Orgfile) {
    return f.filetype === 'task' ? this.auth.isAuthorized('taskedit', f.taskId.split('_')[0]) : true;
  }

  ngOnInit() {
    this.loadFiles();
  }

  loadFiles() {
    if (this.filetype === 'task') {
      this.flsrv.getTaskFilelist(this.projectId).pipe(untilDestroyed(this)).subscribe(flist => {
        //console.log('flist', flist);
        this.processFileList(flist.filter(x => x.taskId.split('_')[0] === this.entityid.split('_')[0]));

      });
    } else if (this.filetype === 'org') {
      this.flsrv.getOrgFilelist(SessionHelper.getChoosenOrg()).pipe(untilDestroyed(this)).subscribe(flist => {
        this.processFileList(flist);
        this.loadOrgProjects();
      });
    } else if (this.filetype === 'org-customer') {
      this.flsrv.getOrgFilelist(SessionHelper.getChoosenOrg()).pipe(untilDestroyed(this)).subscribe(flist => {
        this.filelist = flist.filter(x => x.customerId && x.customerId.split('_')[0] === this.entityid.split('_')[0]);
        this.numberOfFiles.emit(this.filelist.length);
        this.showNoFilesMsg = this.filelist.length === 0;
        this.loadAllFileContent();
      });
      this.loadCustomerProjects();
    } else if (this.filetype === 'customer') {
      const customerId = this.entityid || JSON.parse(SessionHelper.getCustomer()).customerId.split('_')[0];
      this.flsrv.getCustomerFilelist(customerId).pipe(untilDestroyed(this)).subscribe(flist => {
        this.processFileList(flist);
        this.loadCustomerProjects();
      });
    }
  }

  // Process the file list and load file contents
  processFileList(flist: Orgfile[]) {
    this.filelist = flist;
    //console.log('filelist', this.filelist);
    this.filteredfilelist = this.filelist;
    this.numberOfFiles.emit(this.filelist.length);
    this.showNoFilesMsg = this.filelist.length === 0;
    // this.loadAllFileContent();
  }

  // Load content for all files in the list
  loadAllFileContent() {
    this.filelist.forEach(file => {
      this.loadFileContent(file);
    });
  }

  loadOrgProjects() {
    this.datastore.projectList$.pipe(untilDestroyed(this)).subscribe(plist => {
      plist.forEach(cp => {
        this.filters.push({
          title: cp.title,
          type: 'project',
          entity: cp.projectId.split('_')[0],
          state: 'filter'
        });
        this.filteredfilter.push({
          title: cp.title,
          type: 'project',
          entity: cp.projectId,
          state: 'filter'
        });
      });
    });
  }

  loadCustomerProjects() {
    this.flsrv.getCustomerProjects(new Date().toISOString(), this.entityid).pipe(untilDestroyed(this)).subscribe(custpro => {
      custpro.forEach(cp => {
        this.filters.push({
          title: cp.title,
          type: 'project',
          entity: cp.projectId,
          state: 'filter'
        });
        this.filteredfilter.push({
          title: cp.title,
          type: 'project',
          entity: cp.projectId,
          state: 'filter'
        });
      });
    });
  }

  toggleDelete(file?: Orgfile) {
    this.deleteconfirm = !this.deleteconfirm;
    this.fileToDelete = file;
    this.toggledeletefile = file.fileId;
  }

  deleteFile(ofile?: Orgfile) {
    if (ofile) {
      this.fileToDelete = ofile;
    }
    this.flsrv.deleteFile(this.fileToDelete).pipe(untilDestroyed(this)).subscribe(() => {
      this.filelist = this.filelist.filter(f => f !== this.fileToDelete);
      this.fileCache.delete(this.fileToDelete.filename); // Remove from cache
      this.numberOfFiles.emit(this.filelist.length);
      this.deleteconfirm = false;
      this.fileToDelete = null;
      this.togglertasklistfiles = null;
      this.toggledeletefile = null;
    });
  }

  filterfilelist() {
    if (!this.activeFilters || this.activeFilters.length < 1) {
      this.filteredfilelist = this.filelist;
    } else {
      this.filteredfilelist = this.filelist.filter(fil =>
        this.activeFilters.some(af => fil.projectId.split('_')[0] === af.entity.split('_')[0])
      );
    }
    //console.log('filteredfilelist', this.filteredfilelist);
  }

  toggletaskfilelist(id?: Orgfile) {
    this.togglertasklistfiles = id.fileId;
  }

  toggletaskfilelistoff() {
    this.togglertasklistfiles = null;
  }
}
